import { AdvancedPlansFeature, StringMap } from 'types';
import { isSpecEnabled } from './isSpecEnabled';

export function isIncludedBySpec(feature: AdvancedPlansFeature, experiments: StringMap) {
  if (typeof feature.includedBySpec === 'string') {
    return isSpecEnabled(experiments[feature.includedBySpec]);
  }
  return feature.includedBySpec?.some(
    (spec) => isSpecEnabled(experiments[spec]),
  );
}

export function isExcludedBySpec(feature: AdvancedPlansFeature, experiments: StringMap) {
  if (typeof feature.excludedBySpec === 'string') {
    return !isSpecEnabled(experiments[feature.excludedBySpec]);
  }
  return !feature.excludedBySpec?.some(
    (spec) => isSpecEnabled(experiments[spec]),
  );
}


export function filterFeaturesBySpec(
  features: AdvancedPlansFeature[],
  experiments: StringMap,
): AdvancedPlansFeature[] {
  return features.filter((feature) => {

    if (feature.includedBySpec && feature.excludedBySpec) {
      const isInclude = isIncludedBySpec(feature, experiments);
      const isExclude = isExcludedBySpec(feature, experiments);
      return isInclude && !isExclude;
    }

    if (feature.includedBySpec) {
      return isIncludedBySpec(feature, experiments);
    }

    if (feature.excludedBySpec) {
      return isExcludedBySpec(feature, experiments);
    }

    return true;
  });
}
